export const WP_API_BASE = '/wp-json/dhsv/v2/sre/'
